export default __webpack_public_path__ + "5921afb1c3e6673d31a79697175df491.jpg";